import axios from "@/plugins/axios.js"

const actions = {
  fetchMeetings({ commit, state}, payload = {}) {
    return new Promise((resolve, reject) => {
      axios.get(`/meetings?${new URLSearchParams(payload).toString()}`)
        .then((response) => {
          if(response.data.success){
            commit('SET_MEETINGS', response.data.data)
          }
          resolve(response)
        }).catch((error) => { reject(error) })
    })
  },
  fetchAllMeetings({ commit, state }, force = false) {
    return new Promise((resolve, reject) => {
      if(!force && state.list.length) return resolve(true)
      axios.get("/meetings/all")
        .then((response) => {
          if(response.data.success){
            commit('SET_ALL_MEETINGS', response.data.data)
          }
          resolve(response)
        }).catch((error) => { reject(error) })
    })
  },
}

const getters = {
   
}


const mutations = {
  ADD_MEETING(state, item){
    state.pageData.data.unshift(item);
  },
  SET_ALL_MEETINGS(state, list){
    state.list = list
  },
  SET_MEETINGS(state, data) {
    state.pageData = data
  },
  DELETE_MEETING(state, itemId){
    const itemIndex = state.pageData.data.findIndex((item) => item.id == itemId)
    state.pageData.data.splice(itemIndex, 1)
  },
}

const state = {
  list: [],
  pageData: {
    data: []
  },
}


export default {
  isRegistered: true,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}

